import React, { Component } from "react";
import { useStaticQuery, graphql, Link, StaticQuery } from "gatsby";

interface MenuItem {
  link: string,
  label: string,
  children?: MenuItem[]
}

export default class Nav extends Component<{menuOpen: boolean}> {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query MainMenuQuery {
            site {
              siteMetadata {
                mainMenu {
                  label
                  link
                  children {
                    label
                    link
                  }
                }
              }
            }
          }
        `}
        render={data => (
          <>
            <ul className="nav">
              {data.site.siteMetadata?.mainMenu?.map((menuItem: MenuItem) => {
                return (
                  <li key={menuItem.link} className="inline-block">
                    <Link to={menuItem.link} 
                      className="text-yellow-100 font-semibold hover:text-white"
                    ><span>{menuItem.label}</span></Link>
                    {menuItem.children && (
                      <ul>
                        { menuItem.children.map(subMenuItem => {
                            return (
                              <li key={subMenuItem.link} className="inline-block">
                              <Link to={subMenuItem.link} 
                                className="text-yellow-100 font-semibold hover:text-white"
                              ><span>{subMenuItem.label}</span></Link>
                              </li>
                            )
                          })
                        }
                      </ul>
                    ) }
                  </li>
                );
              })}
            </ul>
            <ul className={`${this.props.menuOpen ? 'flex' : 'hidden'} md:hidden flex-col absolute left-0 top-16 w-full bg-gradient-to-br from-pink-300 to-red-400 shadow-lg`}>
              {data.site.siteMetadata?.mainMenu?.map((menuItem: MenuItem) => {
                return (
                  <li key={menuItem.link} className="inline-block text-center font-light text-lg py-3 shadow-sm">
                    <Link to={menuItem.link} 
                      className="text-yellow-100 font-semibold hover:text-white"
                    ><span>{menuItem.label}</span></Link>
                  </li>
                );
              })}
            </ul>
          </>
        )}
      />
    );
  }
};
